var _defs, _rect, _polygon, _rect2, _polygon2, _rect3, _polygon3, _rect4, _polygon4, _rect5, _polygon5, _rect6, _polygon6, _rect7, _polygon7, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinterNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc84d;}.cls-2{fill:#ffb232;}.cls-3{fill:#6b287c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snow-flake-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.82,
    y: 109.59,
    width: 60.34,
    height: 60.34,
    transform: "translate(-22.9 17.75) rotate(-10)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.51 174.71 124.94 164.23 55.03 115.28 65.51 174.71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.84,
    y: 342.08,
    width: 60.34,
    height: 60.34,
    transform: "translate(-58.23 78.94) rotate(-10)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "397.54 407.19 456.96 396.72 387.06 347.77 397.54 407.19"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.84,
    y: 109.59,
    width: 60.34,
    height: 60.34,
    transform: "translate(211.1 531.09) rotate(-80)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.49 174.71 387.06 164.23 456.96 115.28 446.49 174.71"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.82,
    y: 342.07,
    width: 60.34,
    height: 60.34,
    transform: "translate(-292.23 396.22) rotate(-80)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.46 407.19 55.03 396.72 124.94 347.77 114.46 407.19"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 225.83,
    y: 225.83,
    width: 60.34,
    height: 60.34,
    transform: "translate(-106.04 256) rotate(-45)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.67 256 256 298.67 256 213.33 298.67 256"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 225.83,
    y: 23.16,
    width: 60.34,
    height: 60.34,
    transform: "translate(37.27 196.64) rotate(-45)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.67 53.33 256 96 256 10.67 298.67 53.33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 225.83,
    y: 428.5,
    width: 60.34,
    height: 60.34,
    transform: "translate(-249.35 315.36) rotate(-45)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.67 458.67 256 501.33 256 416 298.67 458.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457,335.44a10.68,10.68,0,0,0-12.36-8.65l-55.07,9.71L357.49,314,399,306.72a10.67,10.67,0,1,0-3.7-21l-62.5,11-35.15-24.61,8.58-8.58a10.66,10.66,0,0,0,0-15.08l-8.58-8.58,35.15-24.61,62.5,11a10.82,10.82,0,0,0,1.86.16A10.67,10.67,0,0,0,399,205.28L357.49,198l32.08-22.46,55.07,9.71a10.84,10.84,0,0,0,1.86.16A10.67,10.67,0,0,0,457,176.56l10.48-59.42a10.67,10.67,0,0,0-8.65-12.36L399.39,94.3A10.67,10.67,0,0,0,387,102.95L377.33,158l-32.08,22.46L352.56,139a10.67,10.67,0,0,0-21-3.71l-11,62.5-38.23,26.76-15.64-15.64V169.75l44.88-44.87a10.67,10.67,0,0,0-15.08-15.08l-29.79,29.79V100.42l39.54-39.54a10.66,10.66,0,0,0,0-15.08L263.54,3.13a10.66,10.66,0,0,0-15.08,0L205.79,45.79a10.66,10.66,0,0,0,0,15.08l39.54,39.54v39.17l-29.79-29.79a10.67,10.67,0,0,0-15.08,15.08l44.88,44.88v39.17l-15.64,15.64-38.23-26.77-11-62.5a10.67,10.67,0,0,0-21,3.71l7.32,41.49L134.67,158,125,103a10.69,10.69,0,0,0-12.36-8.65L53.18,104.78a10.67,10.67,0,0,0-8.65,12.36L55,176.56a10.66,10.66,0,0,0,10.51,8.81,10.57,10.57,0,0,0,1.85-.16l55.07-9.71L154.51,198,113,205.28a10.67,10.67,0,0,0,1.84,21.17,10.82,10.82,0,0,0,1.86-.16l62.5-11,35.15,24.61-8.58,8.58a10.66,10.66,0,0,0,0,15.08l8.58,8.58-35.15,24.61-62.5-11a10.67,10.67,0,1,0-3.7,21L154.51,314,122.43,336.5l-55.07-9.71A10.68,10.68,0,0,0,55,335.44L44.53,394.86a10.67,10.67,0,0,0,8.65,12.36l59.42,10.47a10.85,10.85,0,0,0,1.86.16A10.67,10.67,0,0,0,125,409L134.67,354l32.08-22.46L159.44,373a10.67,10.67,0,0,0,8.65,12.36,10.82,10.82,0,0,0,1.86.16,10.67,10.67,0,0,0,10.49-8.81l11-62.5,38.23-26.76,15.64,15.64v39.17l-44.87,44.88a10.67,10.67,0,0,0,15.08,15.08l29.79-29.79v39.17l-39.54,39.54a10.66,10.66,0,0,0,0,15.08l42.67,42.67a10.66,10.66,0,0,0,15.08,0l42.67-42.67a10.66,10.66,0,0,0,0-15.08l-39.54-39.54V372.42l29.79,29.79a10.67,10.67,0,0,0,15.08-15.08l-44.87-44.87V303.08l15.64-15.64,38.23,26.76,11,62.5A10.67,10.67,0,0,0,342,385.52a10.82,10.82,0,0,0,1.86-.16A10.67,10.67,0,0,0,352.56,373l-7.32-41.49L377.33,354,387,409a10.67,10.67,0,0,0,10.49,8.81,10.82,10.82,0,0,0,1.86-.16l59.42-10.47a10.67,10.67,0,0,0,8.65-12.36ZM406.2,117.16l38.41,6.77-6.77,38.42-38.41-6.77Zm-332,45.19-6.77-38.42,38.41-6.77,6.77,38.42ZM105.8,394.84l-38.41-6.77,6.77-38.42,38.41,6.77ZM228.42,256,256,228.42,283.58,256,256,283.58ZM256,25.75l27.58,27.58L256,80.92,228.42,53.33Zm0,460.5-27.58-27.58L256,431.08l27.58,27.58Zm150.2-91.41-6.77-38.42,38.41-6.77,6.77,38.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterNew);
export default __webpack_public_path__ + "static/media/winter-new.7569c4734bab95176c0b5352323e55c8.svg";
export { ForwardRef as ReactComponent };